<template>
    <div class="filters">
        <div class="filter">
            <span class="filter-name">이름: </span>
            <el-input class="medium-filter"
                      placeholder="완성된 한글,영문,숫자만 2자 이상"
                      v-model="name"
                      maxlength="20"
                      show-word-limit>
            </el-input>
        </div>
        <div class="filter">
            <span class="filter-name">전화번호: </span>
            <el-input class="small-filter"
                      placeholder="'-' 제외 입력"
                      v-model="phone"
                      maxlength="11"
                      show-word-limit>
            </el-input>
        </div>
        <div class="filter">
            <span class="filter-name">유저ID: </span>
            <el-input class="small-filter"
                      placeholder="유저ID를 입력하세요."
                      v-model="userId">
            </el-input>
        </div>
        <div class="filter">
            <span class="filter-name">상태: </span>
            <el-select class="mini-filter"
                       v-model="isValid"
                       placeholder="상태를 선택하세요.">
                <el-option label="전체" :value="null"></el-option>
                <el-option label="정상" :value="true"></el-option>
                <el-option label="정지" :value="false"></el-option>
            </el-select>
        </div>
        <el-button type="primary" size="medium" @click.prevent="changeFilter">검색</el-button>
    </div>
</template>

<script>
    import {USER_SET_FILTER} from '@/store/modules/user';

    export default {
        name: 'UserListFilter',
        data() {
            return {
                name: '',
                phone: '',
                userId: '',
                isValid: null,
            };
        },
        computed: {
            filters() {
                return this.$store.state.user.filters;
            },
        },
        methods: {
            async changeFilter() {
                await this.applyFilter('name');
                await this.applyFilter('phone');
                await this.applyFilter('userId');
                await this.applyIsValidFilter();
            },
            async applyFilter(key) {
                let value = this[key]?.trim();
                if (!value) {
                    value = null;
                }
                await this.$store.dispatch(USER_SET_FILTER, {key, value});
            },
            async applyIsValidFilter() {
                await this.$store.dispatch(USER_SET_FILTER, {key: 'isValid', value: this.isValid});
            },
        },
        created() {
            this.name = this.filters.name;
            this.phone = this.filters.phone;
            this.userId = this.filters.userId;
            this.isValid = this.filters.isValid;
        },
    };
</script>

<style lang="scss" scoped>

</style>